const formatCode = (couponCode) => couponCode.trimEnd();
export default formatCode;
//# sourceMappingURL=formatCode.js.map